import { RouterProvider } from "react-router-dom";
import "./App.scss";
import { Router } from './routes/route';
import RtqGridLayoutProvider from "./components/GridLayout/RtqGridLayoutProvider";
// import { useUrfPostEvents, useUrfReceiveEvents } from "./hooks/urfEvents";
// useUrfReceiveEvents

function App() {
  // useUrfReceiveEvents();
  return (
    <div className="rims-app">
      <RtqGridLayoutProvider>
        <RouterProvider router={Router} />
      </RtqGridLayoutProvider>
    </div>
  );
}

export default App;
